import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './Overview'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewInitiativeModel } from 'functions/app/initiative/view'
import { initiativeTabs } from './initiativeTabs'

export const TabContent = ({
  initiative,
}: {
  initiative: ViewInitiativeModel
}) => {
  const translations = useTranslations().app.initiativePage
  const [tab, setTab] = useParamState(initiativeTabs)
  return (
    <Column alignItems="stretch" gap="2rem">
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: translations.overview, value: initiativeTabs.overview },
          { label: translations.thread, value: initiativeTabs.thread },
        ]}
      />
      {match(tab)
        .with(initiativeTabs.overview, () => (
          <Overview key="overview" initiative={initiative} />
        ))
        .with(initiativeTabs.thread, () =>
          initiative.thread?.id ? (
            <Thread key="thread" threadId={initiative.thread.id} />
          ) : null,
        )
        .exhaustive()}
    </Column>
  )
}
